import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import {
  getProductsForAccountV2,
  getHeatProductsForAccount,
  getOrderStatus,
  getTrackAndTraceOrderStatus,
  getMaintenanceDetailsByAgreement,
  getContractExtension,
  getContractExtensionV3,
  putProductsOrderForCustomer,
  putProductsOrderForCustomerV2,
  calculateFineCancelledCustomerProducts,
  getCustomerAccountProductsStatus,
  putDiscontinueConfirmation,
  getDiscontinueIntake,
  putRelocationsCancelation,
  getRelocationCancellationIntake,
} from '../services/ProductsService';

export const useProductsGetProductsForAccountV2 = createDCHook(
  'getProductsForAccountV2',
  collapseDataFromCall(getProductsForAccountV2),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useProductsGetHeatProductsForAccount = createDCHook(
  'getHeatProductsForAccount',
  collapseDataFromCall(getHeatProductsForAccount),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useProductsGetOrderStatus = createDCHook(
  'getOrderStatus',
  collapseDataFromCall(getOrderStatus),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
  { maxAge: 15000 },
);

export const useProductsGetTrackAndTraceOrderStatus = createDCHook(
  'getTrackAndTraceOrderStatus',
  collapseDataFromCall(getTrackAndTraceOrderStatus),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useProductsGetMaintenanceDetailsByAgreement = createDCHook(
  'getMaintenanceDetailsByAgreement',
  collapseDataFromCall(getMaintenanceDetailsByAgreement),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useProductsGetContractExtension = createDCHook(
  'getContractExtension',
  collapseDataFromCall(getContractExtension),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useProductsGetContractExtensionV3 = createDCHook(
  'getContractExtensionV3',
  collapseDataFromCall(getContractExtensionV3),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useProductsPutProductsOrderForCustomer = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(putProductsOrderForCustomer, 'requestBody', 'data'),
      'data',
      'productOffers',
      'deliveryAddress',
      'configuration',
      'isResidence',
      'referenceId',
      'emailAddress',
      'phoneNumbers',
      'desiredAdvancePaymentAmount',
      'b2BCustomerCategoryCriteria',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: [
          'productOffers',
          'deliveryAddress',
          'configuration',
          'isResidence',
          'referenceId',
          'emailAddress',
          'phoneNumbers',
          'desiredAdvancePaymentAmount',
          'b2BCustomerCategoryCriteria',
        ],
      },
    ],
  },
);

export const useProductsPutProductsOrderForCustomerV2 = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(putProductsOrderForCustomerV2, 'requestBody', 'data'),
      'data',
      'productOffers',
      'deliveryAddress',
      'configuration',
      'isResidence',
      'referenceId',
      'emailAddress',
      'phoneNumbers',
      'desiredAdvancePaymentAmount',
      'b2BCustomerCategoryCriteria',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: [
          'productOffers',
          'deliveryAddress',
          'configuration',
          'isResidence',
          'referenceId',
          'emailAddress',
          'phoneNumbers',
          'desiredAdvancePaymentAmount',
          'b2BCustomerCategoryCriteria',
        ],
      },
    ],
  },
);

export const useProductsCalculateFineCancelledCustomerProducts = createMutationHook(
  collapseDataFromCall(
    collapseParams(collapseParams(calculateFineCancelledCustomerProducts, 'requestBody', 'data'), 'data', 'products'),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['products'] },
    ],
  },
);

export const useProductsGetCustomerAccountProductsStatus = createDCHook(
  'getCustomerAccountProductsStatus',
  collapseDataFromCall(getCustomerAccountProductsStatus),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useProductsPutDiscontinueConfirmation = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(putDiscontinueConfirmation, 'requestBody', 'data'),
      'data',
      'date',
      'reason',
      'explanation',
      'referenceId',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['date', 'reason', 'explanation', 'referenceId'] },
    ],
  },
);

export const useProductsGetDiscontinueIntake = createDCHook(
  'getDiscontinueIntake',
  collapseDataFromCall(getDiscontinueIntake),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
);

export const useProductsPutRelocationsCancelation = createMutationHook(
  collapseParams(
    collapseParams(putRelocationsCancelation, 'requestBody', 'data'),
    'data',
    'moveOutDateCurrentAddress',
    'newAddress',
    'isResidence',
    'salesChannel',
    'reason',
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['moveOutDateCurrentAddress', 'newAddress', 'isResidence', 'salesChannel', 'reason'] },
    ],
  },
);

export const useProductsGetRelocationCancellationIntake = createDCHook(
  'getRelocationCancellationIntake',
  collapseDataFromCall(getRelocationCancellationIntake),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);
